export function hasExpiredDemoSignIn() {
  return new URLSearchParams(window.location.search).get('demo_sign_in') === 'expired'
}

export function clearExpiredDemoSignIn() {
  if (!hasExpiredDemoSignIn()) return
  const url = new URL(window.location.href)
  url.searchParams.delete('demo_sign_in')
  window.history.replaceState({}, '', url.pathname + url.search + url.hash)
}
